import { __rest } from '../../../../../../_virtual/_tslib.js';
import React from 'react';
import NavbarBadge from './NavbarBadge.js';
import { checkIfChildIsA, getTarget } from './NavbarHelpers.js';
import { HelixIcon } from '@helix/helix-icon';
import { checkmark } from '@helix/helix-icon/outlined';

var DropdownMenuItem = function DropdownMenuItem(_a) {
  var _b, _c, _d, _e, _f, _g, _h, _j;

  var menuItem = _a.menuItem,
      highlightedIndex = _a.highlightedIndex,
      index = _a.index,
      getItemProps = _a.getItemProps,
      itemFormatter = _a.itemFormatter,
      linkWrapper = _a.linkWrapper,
      itemVisible = _a.itemVisible,
      className = _a.className,
      _onClick = _a.onClick,
      _a$useChildrenInProps = _a.useChildrenInProps,
      useChildrenInProps = _a$useChildrenInProps === void 0 ? false : _a$useChildrenInProps,
      _a$useCheckmarkActive = _a.useCheckmarkActive,
      useCheckmarkActive = _a$useCheckmarkActive === void 0 ? false : _a$useCheckmarkActive,
      rest = __rest(_a, ["menuItem", "highlightedIndex", "index", "getItemProps", "itemFormatter", "linkWrapper", "itemVisible", "className", "onClick", "useChildrenInProps", "useCheckmarkActive"]);

  var activeCheckmark = useCheckmarkActive && (menuItem.active || menuItem.defaultOption) ? React.createElement(HelixIcon, {
    icon: checkmark
  }) : null;

  var itemContent = function itemContent(menuItem) {
    return React.createElement(React.Fragment, null, React.createElement("span", {
      className: 'dropdown-menu-item-content'
    }, React.createElement("span", null, typeof menuItem.label === 'function' ? menuItem.label(menuItem) : menuItem.label, menuItem.badge && menuItem.badge.label !== undefined && !menuItem.badge.hidden && React.createElement(NavbarBadge, null, menuItem.badge.label)), activeCheckmark));
  };

  return React.createElement("li", Object.assign({
    className: "".concat(index === highlightedIndex ? 'highlighted' : '', "\n    ").concat(menuItem.disabled ? ' disabled' : '', " ").concat(menuItem.active && !useCheckmarkActive ? 'active' : '', " ").concat(menuItem.divider ? 'divider' : '', " ").concat(menuItem.header ? 'section-header section-header-bold' : '', " ").concat(className, "\n    ")
  }, rest, getItemProps({
    item: menuItem,
    disabled: menuItem.disabled || itemVisible || menuItem.divider || menuItem.header,
    index: index,
    onClick: function onClick(e) {
      _onClick && _onClick(e);
    }
  })), menuItem.url ? menuItem.disabled ? React.createElement("div", {
    className: 'menu-item-content-wrapper'
  }, itemFormatter ? itemFormatter(menuItem) : itemContent(menuItem)) : React.createElement(React.Fragment, null, linkWrapper ? React.cloneElement(linkWrapper({
    item: menuItem,
    props: {}
  }), {
    children: checkIfChildIsA(linkWrapper, menuItem) ? React.cloneElement((_c = linkWrapper({
      item: menuItem,
      props: Object.assign({}, (_b = linkWrapper({
        item: menuItem,
        props: {
          children: useChildrenInProps ? itemContent(menuItem) : null
        }
      })) === null || _b === void 0 ? void 0 : _b.props)
    })) === null || _c === void 0 ? void 0 : _c.props.children, {
      children: React.createElement(React.Fragment, null, (_e = linkWrapper({
        item: menuItem,
        props: Object.assign({}, (_d = linkWrapper({
          item: menuItem,
          props: {
            children: useChildrenInProps ? itemContent(menuItem) : null
          }
        })) === null || _d === void 0 ? void 0 : _d.props)
      })) === null || _e === void 0 ? void 0 : _e.props.children.props.children, menuItem.badge && menuItem.badge.label !== undefined && !menuItem.badge.hidden && React.createElement(NavbarBadge, null, menuItem.badge.label))
    }) : React.createElement(React.Fragment, null, ((_f = linkWrapper({
      item: menuItem,
      props: {
        children: useChildrenInProps ? itemContent(menuItem) : null
      }
    })) === null || _f === void 0 ? void 0 : _f.props) && ((_g = linkWrapper({
      item: menuItem,
      props: {
        children: useChildrenInProps ? itemContent(menuItem) : null
      }
    })) === null || _g === void 0 ? void 0 : _g.props.children) && ((_j = linkWrapper({
      item: menuItem,
      props: Object.assign({}, (_h = linkWrapper({
        item: menuItem,
        props: {
          children: useChildrenInProps ? itemContent(menuItem) : null
        }
      })) === null || _h === void 0 ? void 0 : _h.props)
    })) === null || _j === void 0 ? void 0 : _j.props.children), menuItem.badge && menuItem.badge.label !== undefined && !menuItem.badge.hidden && React.createElement(NavbarBadge, null, menuItem.badge.label))
  }) : React.createElement("a", Object.assign({
    href: menuItem.url
  }, getTarget(menuItem)), React.createElement(React.Fragment, null, itemFormatter ? itemFormatter(menuItem) : itemContent(menuItem)))) : React.createElement("div", {
    className: 'menu-item-content-wrapper'
  }, React.createElement(React.Fragment, null, " ", itemFormatter ? itemFormatter(menuItem) : itemContent(menuItem))));
};

export { DropdownMenuItem as default };